import { GuardedComponent } from '../components/guarded-component';
import EmailLogPage from '../features/masters/email-log/email-log.page';
import { UserPermissionName } from '../models/user-permission-name';

export const EmailLogRoute = {
  path: '/email-log',
  name: 'Email Log',
  children: [
    {
      index: true,
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_EMAILLOG]} showPermissionError>
          <EmailLogPage />
        </GuardedComponent>
      ),
    },
  ],
};
